module.exports = __webpack_public_path__ + "static/img/product/404.png";